/* eslint-disable react-hooks/exhaustive-deps */
import dayjs from "dayjs";
import React, { useEffect, useRef, useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { IDatePicker } from "../../utils/icons.utils";

const DateRangePicker = ({ handleDateFilter, minDate }) => {
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState();
  const startDateRef = useRef(null);
  const endDateRef = useRef(null);

  const handleStartDateClick = () => {
    startDateRef.current.setFocus(true);
  };

  const handleEndDateClick = () => {
    endDateRef.current.setFocus(true);
  };
  useEffect(() => {
    handleDateFilter({
      startDate: startDate
        ? dayjs(startDate)
            // .add("1", "day")
            .toISOString()
        : "",
      endDate: endDate ? dayjs(endDate).add("1", "day").toISOString() : "",
    });
  }, [startDate, endDate]);

  return (
    <div className="border-2 border-[#F8F7F7] flex date-range-picker w-72  bg-white  py-1 pl-1 rounded-md">
      <div className="date-input flex text-dark_red text-sm font-semibold ml-4">
        <img
          src={IDatePicker}
          alt="IDatePicker"
          className="mr-1 cursor-pointer h-[1.3rem] pt-1"
          onClick={handleStartDateClick}
        />
        <DatePicker
          ref={startDateRef}
          minDate={minDate}
          maxDate={new Date()}
          className="w-[100%] px-1 pt-1 bg-transparent"
          selected={startDate}
          onChange={(date) => setStartDate(date)}
          placeholderText="Start Date"
          wrapperClassName="date-picker-wrapper"
          dateFormat="MM/dd/yyy"
        />
      </div>
      <span className="w-[15px] mt-1 pl-">-</span>

      <div className="date-input flex text-dark_red text-sm font-semibold ml-7 ">
        <img
          src={IDatePicker}
          alt="IDatePicker"
          className="mr-1 cursor-pointer h-[1.3rem] pt-1"
          onClick={handleEndDateClick}
        />
        <DatePicker
          ref={endDateRef}
          maxDate={new Date()}
          minDate={startDate || minDate}
          className="w-[100%] px-1 pt-1 bg-transparent"
          selected={endDate}
          onChange={(date) => setEndDate(date)}
          placeholderText="End Date"
          wrapperClassName="date-picker-wrapper"
          dateFormat="MM/dd/yyy"
        />
      </div>
    </div>
  );
};

export default DateRangePicker;
